<script>

    import {ACTIONS} from "@intellectability/platform-common/constants";
    import {AutoUpdateInput, Button, Modal} from "@intellectability/platform-common/sv";
    import {actionCheck} from "@intellectability/platform-common/utils";

    import {userSecurity} from "@intellectability/platform-common/sv/state";
    import {Col, Row} from "@sveltestrap/sveltestrap";

    const hasAccess = $derived(actionCheck(userSecurity.userActions));

    const {USER_DETAILS_ADD_TRAINING} = ACTIONS;

    let showModal = $state(true);

    let availableCourses = $state.raw([
        {
            course_id: 1,
            assigned: false,
            name: "Course 1",
            instructor: "Alex Davis",
            requiredness: "N/A",
            type: "Online"
        }
    ]);

    let courseOptions = $derived(availableCourses.map(function (course) {
        return {label: course.name, value: course.course_id};
    }));


    const today = new Date();

    const oneMonthFromToday = new Date(today.setMonth(today.getMonth() + 1)).toISOString().split("T")[0];

    let defaultValues = {
        optionality: "N/A",
        selectedCourse: "",
        start_date: oneMonthFromToday
    };


</script>

{#if hasAccess(USER_DETAILS_ADD_TRAINING)}
    <div class="d-flex justify-content-end">
        <Button
                appearance="accent"
                onclick={() => showModal = true}
                prefixIcon="circle-plus"
                variant="success"
        >
            Assign Course
        </Button>
    </div>

    <Modal bind:showModal={showModal} title="Available Courses" size="xl">
        <div class="p-3">
            <div class="mb-4">
                <AutoUpdateInput
                        defaultValue=""
                        fieldName="selectedCourse"
                        label="Select Course"
                        searchable={true}
                        type="select"
                        optionsFrom={courseOptions}
                />
            </div>

            <Row class="mb-4">
                <Col xs="12" lg="6" class="mb-4 mb-lg-0">
                    <AutoUpdateInput
                            defaultValue="N/A"
                            fieldName="optionality"
                            label="Optionality"
                            optionsFrom={["N/A"]}
                            searchable={false}
                            type="select"
                    />
                </Col>
                <Col xs="12" lg="6">
                    <AutoUpdateInput
                            label="Due Date"
                            defaultValue={defaultValues.start_date}
                            type="date"
                    />
                </Col>
            </Row>

            <div class="mb-3">
                <AutoUpdateInput
                        defaultValue={"N"}
                        label="Add new instance of this course, such as for recertification"
                        type="switch"
                />
            </div>
            <div class="mb-5">
                <AutoUpdateInput
                        defaultValue={"N"}
                        label="Replace all existing instances and remove records for this course"
                        type="switch"
                />
            </div>
            <div class="d-flex justify-content-between">
                <Button variant="neutral" appearance="filled" onclick={() => showModal = false}>
                    Cancel
                </Button>
                <Button variant="success" appearance="filled">Save</Button>
            </div>
        </div>
    </Modal>
{/if}